import { withStyles, Grid, Typography, Paper } from '@material-ui/core';
import React from 'react'; // eslint-disable-line
import styles, { StyledComponent } from '../../../../../styles/styles';
import { LabeledValue } from '../../../../../controls/labeled-value';
import { FormDetails, getFormDetails } from '../form-details-reducer';
import { connect } from 'react-redux';
import { State } from '../../../../../redux/root-reducer';
import { getDisplayDate } from '../../../../../shared-functions';
import { OpenModal, openModalAction } from '../../../../../form-modal/actions';
import { UpdateFormDetails, updateFormDetailsAction } from '../actions/update-form-details';
import { getClaim } from '../../../../../claim';
import { Nullable } from '../../../../../shared-types';
import { ClaimType } from '../../../../../claim/claim-types';

interface BaseProps {
    formDetails?: FormDetails;
    updateFormDetails?: UpdateFormDetails;
    disableEditButton?: boolean;
    claimType?: Nullable<ClaimType>;
}
interface Props extends BaseProps, StyledComponent {
    readonly openModal: OpenModal;
}

const medicalAidDetailsView: React.FunctionComponent<Props> = ({
    classes,
    formDetails,
    claimType,
}: Props) => {
    const medicalAidDetails = formDetails?.lifeAssured?.medicalAidDetails;
    const isOtherMedicalAidSelected = medicalAidDetails?.medicalAidName?.toLowerCase() === 'other';
    const hasMedicalAid = medicalAidDetails?.doesTheLifeAssuredHaveAMedicalAid === 'Yes';
    const isMainMemberOnMedicalAid =
        medicalAidDetails?.isLifeAssuredMainMemberOnTheMedicalAid === 'Yes';
    const isNotMainMemberOnMedicalAid =
        medicalAidDetails?.isLifeAssuredMainMemberOnTheMedicalAid === 'No';

    return (
        <React.Fragment>
            <Grid container justify="space-between" className={classes.marginTop2}>
                <Grid container item xs={10} alignItems="center">
                    <Typography style={{ padding: 10 }} className={classes.heading} variant="body1">
                        Medical Aid details
                    </Typography>
                </Grid>
            </Grid>
            <Paper className={classes.paper}>
                {isDreadOrTerminal() && (
                    <Grid container justify="flex-start">
                        <Grid item xs={12} container justify="flex-start">
                            <Grid item xs={4} lg={12}>
                                <LabeledValue
                                    label="Life Assured has medical aid?"
                                    value={medicalAidDetails?.hasMedicalAid}
                                />
                            </Grid>
                            {medicalAidDetails?.hasMedicalAid === 'Yes' && (
                                <Grid item xs={4} lg={3}>
                                    <LabeledValue
                                        label="Medical aid number"
                                        value={medicalAidDetails?.lifeAssuredMedicalAidNumber}
                                    />
                                </Grid>
                            )}
                            {medicalAidDetails?.hasMedicalAid === 'Yes' && (
                                <Grid item xs={4} lg={3}>
                                    <LabeledValue
                                        label="Medical aid name"
                                        value={medicalAidDetails?.lifeAssuredMedicalAidName}
                                    />
                                </Grid>
                            )}
                            {medicalAidDetails?.hasMedicalAid === 'Yes' && (
                                <Grid item xs={4} lg={3}>
                                    <LabeledValue
                                        label="Date Joined"
                                        value={getDisplayDate(
                                            medicalAidDetails?.lifeAssuredMedicalDateJoined
                                        )}
                                    />
                                </Grid>
                            )}
                            {medicalAidDetails?.hasMedicalAid === 'Yes' && (
                                <Grid item xs={4} lg={3}>
                                    <LabeledValue
                                        label="Is the life assured a main member"
                                        value={medicalAidDetails?.isLifeAssuredMainMember}
                                    />
                                </Grid>
                            )}
                        </Grid>
                        {medicalAidDetails?.hasMedicalAid === 'Yes' &&
                            medicalAidDetails?.isLifeAssuredMainMember === 'No' && (
                                <Grid item xs={4} lg={3}>
                                    <LabeledValue
                                        label="Main member Title"
                                        value={medicalAidDetails?.lifeAssuredTitle}
                                    />
                                </Grid>
                            )}
                        {medicalAidDetails?.hasMedicalAid === 'Yes' &&
                            medicalAidDetails?.isLifeAssuredMainMember === 'No' && (
                                <Grid item xs={4} lg={3}>
                                    <LabeledValue
                                        label="Main member full name"
                                        value={medicalAidDetails?.lifeAssuredName}
                                    />
                                </Grid>
                            )}
                        {medicalAidDetails?.hasMedicalAid === 'Yes' &&
                            medicalAidDetails?.isLifeAssuredMainMember === 'No' && (
                                <Grid item xs={4} lg={3}>
                                    <LabeledValue
                                        label="Main member surname"
                                        value={medicalAidDetails?.lifeAssuredSurname}
                                    />
                                </Grid>
                            )}
                        {medicalAidDetails?.hasMedicalAid === 'Yes' &&
                            medicalAidDetails?.isLifeAssuredMainMember === 'No' && (
                                <Grid item xs={4} lg={3}>
                                    <LabeledValue
                                        label="Main member ID"
                                        value={medicalAidDetails?.lifeAssuredIdNumber}
                                    />
                                </Grid>
                            )}
                    </Grid>
                )}
                {isDisabilityOrRetrenchment() && (
                    <Grid container justify="flex-start">
                        <Grid item xs={12} container justify="flex-start">
                            {claimType === ClaimType.Disability && (
                                <Grid item xs={4} lg={12}>
                                    <LabeledValue
                                        label="Does the life assured have a medical aid?"
                                        value={medicalAidDetails?.doesTheLifeAssuredHaveAMedicalAid}
                                    />
                                </Grid>
                            )}
                            {claimType === ClaimType.Retrenchment && (
                                <Grid item xs={4} lg={3}>
                                    <LabeledValue
                                        label="Does the life assured have a medical aid?"
                                        value={medicalAidDetails?.doesTheLifeAssuredHaveAMedicalAid}
                                    />
                                </Grid>
                            )}
                            {hasMedicalAid && (
                                <>
                                    <Grid item xs={4} lg={3}>
                                        <LabeledValue
                                            label="Medical aid name"
                                            value={medicalAidDetails?.medicalAidName}
                                        />
                                    </Grid>
                                    {isOtherMedicalAidSelected && (
                                        <Grid item xs={4} lg={3}>
                                            <LabeledValue
                                                label="Medical aid name (Other)"
                                                value={medicalAidDetails?.otherMedicalAidName}
                                            />
                                        </Grid>
                                    )}
                                    <Grid item xs={4} lg={3}>
                                        <LabeledValue
                                            label="Medical aid number"
                                            value={medicalAidDetails?.medicalAidNumber}
                                        />
                                    </Grid>
                                    <Grid item xs={4} lg={3}>
                                        <LabeledValue
                                            label="Date Joined"
                                            value={getDisplayDate(medicalAidDetails?.dateJoined)}
                                        />
                                    </Grid>
                                    <Grid item xs={4} lg={3}>
                                        <LabeledValue
                                            label="Is the life assured the main member on the medical aid?"
                                            value={
                                                medicalAidDetails?.isLifeAssuredMainMemberOnTheMedicalAid
                                            }
                                        />
                                    </Grid>

                                    {isNotMainMemberOnMedicalAid && (
                                        <>
                                            <Grid item xs={4} lg={3}>
                                                <LabeledValue
                                                    label="Main member first name"
                                                    value={medicalAidDetails?.mainMembersFirstName}
                                                />
                                            </Grid>
                                            <Grid item xs={4} lg={3}>
                                                <LabeledValue
                                                    label="Main member surname"
                                                    value={medicalAidDetails?.mainMembersSurname}
                                                />
                                            </Grid>
                                            <Grid item xs={4} lg={3}>
                                                <LabeledValue
                                                    label="Main member ID Number / Passport Number"
                                                    value={
                                                        medicalAidDetails?.mainMembersIdNumberOrPassportNumber
                                                    }
                                                />
                                            </Grid>
                                        </>
                                    )}

                                    {isMainMemberOnMedicalAid && (
                                        <>
                                            <Grid item xs={4} lg={3}>
                                                <LabeledValue
                                                    label="Main member first name"
                                                    value={
                                                        formDetails?.lifeAssured?.personalDetails
                                                            ?.firstName ||
                                                        formDetails?.lifeAssured?.personalDetails
                                                            ?.lifeAssuredFirstName ||
                                                        formDetails?.lifeAssured?.personalDetails
                                                            ?.fullFirstNames
                                                    }
                                                />
                                            </Grid>
                                            <Grid item xs={4} lg={3}>
                                                <LabeledValue
                                                    label="Main member surname"
                                                    value={
                                                        formDetails?.lifeAssured?.personalDetails
                                                            ?.surname ||
                                                        formDetails?.lifeAssured?.personalDetails
                                                            ?.lifeAssuredSurname
                                                    }
                                                />
                                            </Grid>
                                            <Grid item xs={4} lg={3}>
                                                <LabeledValue
                                                    label="Main member ID Number / Passport Number"
                                                    value={
                                                        formDetails?.lifeAssured?.personalDetails
                                                            ?.idNumber ||
                                                        formDetails?.lifeAssured?.personalDetails
                                                            ?.lifeAssuredIdNumber ||
                                                        formDetails?.lifeAssured?.personalDetails
                                                            ?.lifeAssuredPassportNumber
                                                    }
                                                />
                                            </Grid>
                                        </>
                                    )}
                                </>
                            )}
                        </Grid>
                    </Grid>
                )}
            </Paper>
        </React.Fragment>
    );
    function isDisabilityOrRetrenchment() {
        return claimType === ClaimType.Disability || claimType === ClaimType.Retrenchment;
    }
    function isDreadOrTerminal() {
        return claimType === ClaimType.Dread || claimType === ClaimType.TerminalIllness;
    }
};

const mapStateToProps = (state: State, ownProps: BaseProps) => ({
    formDetails: ownProps.formDetails || getFormDetails(state),
    disableEditButton: ownProps.disableEditButton || false,
    claimType: getClaim(state).claimType,
});

const mapDispatchToProps = {
    openModal: openModalAction,
    updateFormDetails: updateFormDetailsAction,
};

export const MedicalAidDetailsView = connect(
    mapStateToProps,
    mapDispatchToProps
)(withStyles(styles)(medicalAidDetailsView));
